module.exports = __webpack_public_path__ + "static/Diana-Pulido-b87eee11dd5884b34fc0158205c368fd.png";